module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1043fc76!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-checkbox-list/index.vue
// module id = 428
// module chunks = 0 1